import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client'

const GET_TAGS = gql`
  query Tag(
    $entityId: String!
    $limit: Int
  ) {
    tag(
      entityId: $entityId
      limit: $limit
    ) {
      items {
        id
        name
      }
    }
  }`

/**
 * Tags Query
 * @param options
 */
export function useTagQuery (options) {
  return useQuery(GET_TAGS, options)
}
